import React from "react";
import bannerImg from "../../assets/images/ld.png";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";

function LGbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          {/* <div className="webbanner-tag">Web Development </div> */}
          <h1>Lead Generation Services to Grow Your Business Faster </h1>
          <p>
            In these days’s aggressive virtual market, producing excellent leads
            is vital for commercial enterprise growth. Companies that target
            targeted strategies and information-pushed advertising are able to
            attract the right target market and convert them into paying
            customers. This is where professional <b>lead generation services</b> play
            a vital position in supporting businesses scale successfully.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Lead Generation Services</span>
      </div>
    </div>
  );
}

export default LGbanner;
